<template>
  <div>

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="userData === undefined"
    >
      <h4 class="alert-heading">
        Erreur lors du chargement de contenu
      </h4>
      <div class="alert-body">
        Aucun utilisateur trouvé pour cette identifiant. Vérifier
        <b-link
          class="alert-link"
          :to="{ name: 'apps-users-list'}"
        >
          Liste des utilisateurs
        </b-link>
        pour les autres utilisateurs
      </div>
    </b-alert>

    <template v-if="userData">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <user-view-user-info-card :user-data="userData" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        > 
        </b-col>
      </b-row>

      <!-- <b-row> 
        <b-col
          cols="12"
          lg="12"
        >
          <user-view-user-permissions-card />
        </b-col>
      </b-row> -->

      <!-- <invoice-list /> -->
    </template>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BRow, BCol, BAlert, BLink,
} from 'bootstrap-vue' 
import userStoreModule from '../storeModule'
import UserViewUserInfoCard from './UserViewUserInfoCard.vue'  
// import UserViewUserPermissionsCard from './UserViewUserPermissionsCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,

    // Local Components
    UserViewUserInfoCard,  
    // UserViewUserPermissionsCard, 
  },
  setup() {
    const userData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-user'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('app-user/fetchUser', { id: router.currentRoute.params.id })
      .then(response => { userData.value = response.data })
      .catch(error => {
        console.log(error.response);
        // if (error.response.status === 404) {
        //   userData.value = undefined
        // }
        userData.value = undefined
      })

    return {
      userData,
    }
  },
}
</script>

<style>

</style>
